import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.scss'],
    standalone: false
})
export class HelpDialogComponent implements OnInit {

  title = this.data.title || 'Aide';
  noTitle = this.data.noTitle || false;

  confirmText = this.data.confirmText || 'OK';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
  }
}
